export const serialize = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => {
      item.id = Number(item.id)
      return item
    })
  } else {
    data.id = Number(data.id)
    return data
  }
}
export const nextDueDate = () => {
  var sunday = 7 // sunday
  var date = new Date()
  var diff = sunday - date.getDay()
  if (diff < 7) {
    date.setDate(date.getDate() + diff)
  } else {
    date.setDate(date.getDate())
  }
  return date
}

// NOTE: RUN-2927 — v2 = checkpoints normalisés porteurs de leur catégorie.
// NOTE: FEAT-4256 — v3 = checkpoints exclus sur l'audit retirés de la liste.
// audits/reload ne re-télécharge que les audits absents en local : ce marqueur
// lui permet de cibler en plus les audits persistés dans une forme antérieure.
// Incrémenter à chaque changement de forme du document audit persisté.
export const AUDIT_SCHEMA_VERSION = 3

export const isAuditSchemaOutdated = (audit) =>
  Number(audit && audit.schemaVersion) !== AUDIT_SCHEMA_VERSION
